import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export interface PoistaLuottokorttilaskunLuomatKirjauksetDialogData {
  asiakasAvain: string
  tositeAvain: string
}

@Component({
  templateUrl: './poista-luottokorttilaskun-luomat-kirjaukset.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PoistaLuottokorttilaskunLuomatKirjauksetDialog {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PoistaLuottokorttilaskunLuomatKirjauksetDialogData,
    private _dialogRef: MatDialogRef<PoistaLuottokorttilaskunLuomatKirjauksetDialog, boolean>,
  ) {}

  poista() {
    this._dialogRef.close(true)
  }
}
